import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import Dashboard from "@/pages/Dashboard";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import Catalog from "@/pages/Catalog";
import Budgets from "@/pages/Budgets";
import BudgetEditor from "@/pages/BudgetEditor";
import Invoices from "@/pages/Invoices";
import InvoiceEditor from "@/pages/InvoiceEditor";
import Clients from "@/pages/Clients";
import Team from "@/pages/Team";
import Profile from "@/pages/Profile";
import SettingsPage from "@/pages/Settings";
import AuditLog from "@/pages/AuditLog";
import Tools from "@/pages/Tools";
import WeekHoursCheck from "@/pages/WeekHoursCheck";
import ToolDetail, { ToolQrRedirect } from "@/pages/ToolDetail";
import Bank from "@/pages/Bank";
import PublicBudget from "@/pages/PublicBudget";
import PublicAddendum from "@/pages/PublicAddendum";
import Planner from "@/pages/Planner";
import MapPage from "@/pages/MapPage";
import Craftsmen from "@/pages/Craftsmen";
import CraftsmenPayroll from "@/pages/CraftsmenPayroll";
import CraftsmanPayrollDetail from "@/pages/CraftsmanPayrollDetail";
import Reklamace from "@/pages/Reklamace";
import PriceListTiles from "@/pages/PriceListTiles";
import PriceListCoatings from "@/pages/PriceListCoatings";
import Reports from "@/pages/Reports";
import Tasks from "@/pages/Tasks";
import Documents from "@/pages/Documents";
import Trips from "@/pages/Trips";
import TripsWeek from "@/pages/TripsWeek";
import Attendance from "@/pages/Attendance";
import MyHours from "@/pages/MyHours";
import ReceivedInvoices from "@/pages/ReceivedInvoices";
import Offers from "@/pages/Offers";
import OfferDetail from "@/pages/OfferDetail";

function PublicOnly({ children }) {
    const { user, loading } = useAuth();
    if (loading) return null;
    if (user) return <Navigate to="/" replace />;
    return children;
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/prihlaseni" element={<PublicOnly><Login /></PublicOnly>} />
                        <Route path="/registrace" element={<PublicOnly><Register /></PublicOnly>} />
                        <Route path="/pozvanka/:token" element={<AcceptInvite />} />
                        <Route path="/zapomenute-heslo" element={<PublicOnly><ForgotPassword /></PublicOnly>} />
                        <Route path="/obnova-hesla/:token" element={<ResetPassword />} />
                        <Route path="/r/:token" element={<PublicBudget />} />
                        <Route path="/dodatek/:token" element={<PublicAddendum />} />
                        <Route element={<Layout />}>
                            <Route path="/" element={<Dashboard />} />
                            <Route path="/planovac" element={<Planner />} />
                            <Route path="/mapa" element={<MapPage />} />
                            <Route path="/zakazky" element={<Jobs />} />
                            <Route path="/zakazky/:id" element={<JobDetail />} />
                            <Route path="/klienti" element={<Clients />} />
                            <Route path="/remeslnici" element={<Craftsmen />} />
                            <Route path="/remeslnici/vyplaty" element={<CraftsmenPayroll />} />
                            <Route path="/remeslnici/vyplaty/:cardId" element={<CraftsmanPayrollDetail />} />
                            <Route path="/remeslnici/zakazka/:jobId" element={<Craftsmen />} />
                            <Route path="/reklamace" element={<Reklamace />} />
                            <Route path="/cenik-dlazby" element={<PriceListTiles />} />
                            <Route path="/cenik-sterky" element={<PriceListCoatings />} />
                            <Route path="/cenik" element={<Catalog />} />
                            <Route path="/rozpocty" element={<Budgets />} />
                            <Route path="/nabidky" element={<Offers />} />
                            <Route path="/nabidky/:id" element={<OfferDetail />} />
                            <Route path="/rozpocty/:id" element={<BudgetEditor />} />
                            <Route path="/faktury" element={<Invoices />} />
                            <Route path="/faktury/:id" element={<InvoiceEditor />} />
                            <Route path="/prijate-faktury" element={<ReceivedInvoices />} />
                            <Route path="/reporty" element={<Reports />} />
                            <Route path="/ukoly" element={<Tasks />} />
                            <Route path="/dokumenty" element={<Documents />} />
                            <Route path="/kniha-jizd" element={<Trips />} />
                            <Route path="/kniha-jizd/tyden" element={<TripsWeek />} />
                            <Route path="/remeslnici/dochazka" element={<Attendance />} />
                            <Route path="/hodiny" element={<MyHours />} />
                            <Route path="/tym" element={<Team />} />
                            <Route path="/profil" element={<Profile />} />
                            <Route path="/nastaveni" element={<SettingsPage />} />
                            <Route path="/historie" element={<AuditLog />} />
                            <Route path="/naradi" element={<Tools />} />
                            <Route path="/kontrola-hodin" element={<WeekHoursCheck />} />
                            <Route path="/naradi/qr/:token" element={<ToolQrRedirect />} />
                            <Route path="/naradi/:id" element={<ToolDetail />} />
                            <Route path="/banka" element={<Bank />} />
                        </Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
